/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_verify_email_confirm_a_e_confirm_post = {
    properties: {
        user_id: {
            type: 'number',
            isRequired: true,
        },
        code: {
            type: 'string',
            isRequired: true,
        },
        csrf: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
